// eslint-disable-next-line @typescript-eslint/no-var-requires
const NodeRSA = require('node-rsa')

export const generateKeyPair = (): { privateKey: string, publicKey: string } => {
  const key = new NodeRSA({ b: 1024 })
  const privateKey = key.exportKey('pkcs1-pem')
  const publicKey = key.exportKey('pkcs8-public-pem')
  return { privateKey, publicKey }
}
